import React from "react";
import { Input } from "reactstrap";
import { loomFor, useStudioLooms } from "./list/studioLooms";

type Props = { value?: string; onChange: (loomNum: string) => void };

/**
 * The product's loom: a pick from the studio's karkhana looms (saved by code, linked by id on the server, so a
 * renamed loom shows its new code here), or plain text for a studio with no looms. A number typed before that
 * is no studio loom stays shown until another is picked.
 */
const LoomNumberField = ({ value, onChange }: Props) => {
  const looms = useStudioLooms();
  if (!looms || !looms.length) {
    return (
      <Input
        type="text"
        name="loomNumber"
        className="form-control"
        placeholder="Loom Number"
        value={value || ""}
        onChange={(e: any) => onChange(e.target.value)}
      />
    );
  }
  const current = loomFor(looms, value);
  const unknown = !current && Boolean(value && value.trim());
  return (
    <Input
      type="select"
      name="loomNumber"
      className="form-control"
      aria-label="Loom Number"
      value={current ? current.code : unknown ? value : ""}
      onChange={(e: any) => onChange(e.target.value)}
    >
      <option value="">No loom</option>
      {unknown ? <option value={value}>{value} (not a studio loom)</option> : null}
      {looms.map((loom) => (
        <option key={loom.id} value={loom.code}>
          {loom.code}
          {loom.retired ? " (retired)" : ""}
        </option>
      ))}
    </Input>
  );
};

export default LoomNumberField;
